import {Theme, Typography, TypographyVariant} from "@mui/material";
import React, {ReactNode, useCallback} from "react";
import {grey} from "@mui/material/colors";

export function useTagSx(color: 'disabled' | 'error' | 'warning' | 'success' | 'primary' | 'secondary' | 'inherit' = 'inherit', clickable: boolean = false) {
    return useCallback((theme: Theme) => {
        const colorSx = color === 'disabled' ? ({
            backgroundColor: grey.A200,
            color: theme.palette.getContrastText(grey.A200),
        }) : color === 'error' ? ({
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        }) : color === 'warning' ? ({
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.warning.contrastText,
        }) : color === 'success' ? ({
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
        }) : color === 'primary' ? ({
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
        }) : color === 'secondary' ? ({
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
        }) : {};

        return {
            ...colorSx,
            borderRadius: '4px',
            px: 1,
            py: '2px',
            cursor: clickable ? 'pointer' : 'default',
        };
    }, [color, clickable]);
}

export function Tag(
    {
        color = 'inherit',
        typography,
        onClick,
        children,
    }: {
        color?: 'disabled' | 'error' | 'warning' | 'inherit' | 'success' | 'primary' | 'secondary',
        typography?: TypographyVariant,
        onClick?: () => void,
        children: ReactNode,
    }
) {
    const sx = useTagSx(color, !!onClick);

    return (
        <Typography
            variant={typography}
            component="span"
            sx={sx}
            onClick={onClick}
        >{children}</Typography>
    );
}